// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/iro/iro.proto (package dymensionxyz.dymension.iro, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3, Timestamp } from "@bufbuild/protobuf";
import { Coin } from "./coin_pb";

/**
 * Params is a module parameters.
 *
 * @generated from message dymensionxyz.dymension.iro.Params
 */
export const Params = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.Params",
  () => [
    { no: 1, name: "taker_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "creation_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "min_plan_duration", kind: "message", T: Duration },
    { no: 4, name: "incentives_min_start_time_after_settlement", kind: "message", T: Duration },
    { no: 5, name: "incentives_min_num_epochs_paid_over", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Bonding curve represents a bonding curve in the IRO module.
 * BondingCurve represents a bonding curve with parameters M, N, and C.
 * The price of the token is calculated as follows:
 * price = M * x^N + C
 *
 * @generated from message dymensionxyz.dymension.iro.BondingCurve
 */
export const BondingCurve = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.BondingCurve",
  () => [
    { no: 1, name: "M", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "N", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "C", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Plan represents a plan in the IRO module.
 *
 * @generated from message dymensionxyz.dymension.iro.Plan
 */
export const Plan = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.Plan",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "module_acc_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_allocation", kind: "message", T: Coin },
    { no: 5, name: "bonding_curve", kind: "message", T: BondingCurve },
    { no: 6, name: "settled_denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "start_time", kind: "message", T: Timestamp },
    { no: 8, name: "pre_launch_time", kind: "message", T: Timestamp },
    { no: 9, name: "sold_amt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "claimed_amt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "incentive_plan_params", kind: "message", T: IncentivePlanParams },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.iro.IncentivePlanParams
 */
export const IncentivePlanParams = proto3.makeMessageType(
  "dymensionxyz.dymension.iro.IncentivePlanParams",
  () => [
    { no: 1, name: "start_time_after_settlement", kind: "message", T: Duration },
    { no: 2, name: "num_epochs_paid_over", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

